// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomPaypalButton_container__3nnaq","buttonWrapper":"CustomPaypalButton_buttonWrapper__3oXy3","paypalButtonWrapper":"CustomPaypalButton_paypalButtonWrapper__12xVw"};